import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { compareAsc, format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  ResponsiveContainer,
  CartesianGrid,
  Tooltip,
  Legend,
  Area,
  ComposedChart,
  ReferenceLine,
} from "recharts";
import MicroModal from "micromodal";

import Typography from "../../../../components/Typography";
import TextSmall from "../../../manager-section/TextComponent/TextSmall";
import Dots from "../../../Loading/Dots/Dots";
import MetaValueModal from "../../../modals/MetaValueModal";

import * as APIDashboard from "../../../../services/nps/functions";

import { ReactComponent as DayWeekIcon } from "../../../../build/images/nps-dashboard-icons/day-week.svg";
import { ReactComponent as GoalIcon } from "../../../../build/images/nps-dashboard-icons/goal.svg";
import { ReactComponent as ClockIcon } from "../../../../build/images/nps-dashboard-icons/clock.svg";
import { ReactComponent as CalendarMonthIcon } from "../../../../build/images/nps-dashboard-icons/calendar_month.svg";
import { ReactComponent as EmptyState } from "../../../../build/images/emptystatemanagerhorizontal.svg";
import { ReactComponent as EditMetaIcon } from "../../../../build/images/editmeta.svg";

import "./nps-evolution.css";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import MetaValueModalV2 from "../../../modals/MetaValueModalV2";
import { groupBy } from "../../../../utils/groupBy";

const buttons = [
  { key: "month", label: "Mês", icon: <CalendarMonthIcon />, type: 1 },
  { key: "day", label: "Data", icon: <DayWeekIcon />, type: 4 },
  { key: "day-week", label: "Dia da semana", icon: <DayWeekIcon />, type: 2 },
  { key: "hours", label: "Hora", icon: <ClockIcon />, type: 3 },
];

export default function NpsEvolution() {
  const filtersDashboard = useSelector((state) => state.npsfilters);

  const [activeButton, setActiveButton] = useState("month");
  const [initialDate, setInitialDate] = useState(filtersDashboard.datestart);
  const [finalDate, setFinalDate] = useState(filtersDashboard.dateend);
  const [dataEvo, setDataEvo] = useState([]);
  const [type, setType] = useState(1);
  const [lastType, setLastType] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dispareFilter, setDispareFilter] = useState(false);
  const [metaValue, setMetaValue] = useState(getMetaValue());
  const [value, setValue] = useState(getMetaValue());

  const data = [
    {
      name: "Page A",
      uv: 4000,
      pv: 2400,
      amt: 10000,
    },
    {
      name: "Page B",
      uv: 3000,
      pv: 1398,
      amt: 10000,
    },
    {
      name: "Page C",
      uv: 2000,
      pv: 9800,
      amt: 10000,
    },
    {
      name: "Page D",
      uv: 2780,
      pv: 3908,
      amt: 10000,
    },
    {
      name: "Page E",
      uv: 1890,
      pv: 4800,
      amt: 10000,
    },
    {
      name: "Page F",
      uv: 2390,
      pv: 3800,
      amt: 10000,
    },
    {
      name: "Page G",
      uv: 3490,
      pv: 4300,
      amt: 10000,
    },
  ];

  const handleDateFormat = (stringDate) => {
    const date = parse(stringDate, "yyyy-MM-dd", new Date());
    const isDateValid = !!date;
    if (isDateValid) {
      const formatedDate = format(date, "dd/MM/yyyy");
      return formatedDate;
    }

    return stringDate;
  };

  function getMetaValue() {
    const [storedValue, setStoredValue] = useLocalStorage("ingWebNPS_goal", 0);
    let goal = 0;
    if (storedValue) {
      goal = storedValue;
    }
    return goal;
  }

  function updateGoalOnNPS(goal, dataToNPSGraphic) {
    let copyOfData = [];
    let dataToUpdate = [];
    if (dataToNPSGraphic) {
      if (dataToNPSGraphic.length) {
        copyOfData = dataToNPSGraphic.slice();
        dataToUpdate = copyOfData.map((data) => {
          return { ...data, meta: goal };
        });
      } else {
        copyOfData = [];
        dataToUpdate = [];
      }
    }
    return dataToUpdate;
  }

  const OpenModalMeta = () => {
    setValue(metaValue);
    MicroModal.show("modal__edit_meta_value");
  };

  const handleMetaValue = () => {
    setMetaValue(value);
    // localStorage.setItem("ingWebNPS_goal", value);
    MicroModal.close("modal__edit_meta_value");
  };

  const handleButtonClick = (button, type) => {
    setActiveButton(button);
    setType(type);
    getNpsQuestVersion3(type);
  };

  async function getNpsQuestVersion3(typeApi) {
    setLoading(true);
    let dataToGenerateGraph = [];

    const response = await APIDashboard.getNpsResultV2(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join(),
      typeApi,
      filtersDashboard.questionsNPS.map((option) => option.id).join(),
      filtersDashboard.questionsCSAT.map((option) => option.id).join(),
      filtersDashboard.channels.map((option) => option.id).join(),
    );
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const results = response.data;
      const hasResults = !!results && results.length > 0;
      if (hasResults) {
        const resultsGroupedByDate = groupBy(results, "data_nps");
        const hasResultsGroupedByDate = !!resultsGroupedByDate;
        if (hasResultsGroupedByDate) {
          const sumNpsProfiles = (
            promoters,
            neutrals,
            detractors,
            profile,
            profileQtd,
          ) => {
            let promotersQtd = promoters;
            let neutralsQtd = neutrals;
            let detractorsQtd = detractors;

            const isPromoter = profile === "promotor";
            const isNeutral = profile === "neutro";
            const isDetractor = profile === "detrator";
            if (isPromoter) {
              promotersQtd = promotersQtd + Number(profileQtd);
            } else if (isNeutral) {
              neutralsQtd = neutralsQtd + Number(profileQtd);
            } else if (isDetractor) {
              detractorsQtd = detractorsQtd + Number(profileQtd);
            }

            return { promotersQtd, neutralsQtd, detractorsQtd };
          };
          for (let date in resultsGroupedByDate) {
            const name = date;
            let npsO = 0;
            let npsT = 0;

            const allDataInThisDate = resultsGroupedByDate[date];
            const hasAllDataInThisDate =
              !!allDataInThisDate && allDataInThisDate.length > 0;
            if (hasAllDataInThisDate) {
              let promotersQtdO = 0;
              let neutralsQtdO = 0;
              let detractorsQtdO = 0;

              let promotersQtdT = 0;
              let neutralsQtdT = 0;
              let detractorsQtdT = 0;

              allDataInThisDate.forEach((dataWithSameDate) => {
                const profileType = dataWithSameDate.tipo;
                const profileQtd = dataWithSameDate.qtde;
                const isOriginalData = !!dataWithSameDate.qtde;
                const isTreatedData = !!dataWithSameDate.resultado_tratativa;
                if (isOriginalData) {
                  const { promotersQtd, neutralsQtd, detractorsQtd } =
                    sumNpsProfiles(
                      promotersQtdO,
                      neutralsQtdO,
                      detractorsQtdO,
                      profileType,
                      profileQtd,
                    );

                  promotersQtdO = promotersQtd;
                  neutralsQtdO = neutralsQtd;
                  detractorsQtdO = detractorsQtd;
                } else if (isTreatedData) {
                  const { promotersQtd, neutralsQtd, detractorsQtd } =
                    sumNpsProfiles(
                      promotersQtdT,
                      neutralsQtdT,
                      detractorsQtdT,
                      profileType,
                      dataWithSameDate.resultado_tratativa,
                    );

                  promotersQtdT = promotersQtd;
                  neutralsQtdT = neutralsQtd;
                  detractorsQtdT = detractorsQtd;
                }
              });

              const totalO = promotersQtdO + neutralsQtdO + detractorsQtdO;
              const promotersPercentageO = totalO
                ? (promotersQtdO / totalO) * 100
                : 0;
              const detractorsPercentageO = totalO
                ? (detractorsQtdO / totalO) * 100
                : 0;

              const totalT = promotersQtdT + neutralsQtdT + detractorsQtdT;
              const promotersPercentageT = totalT
                ? (promotersQtdT / totalT) * 100
                : 0;
              const detractorsPercentageT = totalT
                ? (detractorsQtdT / totalT) * 100
                : 0;

              npsO = promotersPercentageO - detractorsPercentageO;
              npsT = promotersPercentageT - detractorsPercentageT;
            }

            dataToGenerateGraph.push({
              name,
              npsO,
              npsT,
              meta: metaValue,
            });
          }
        }
      }

      const hasDataToGenerateGraph =
        !!dataToGenerateGraph && dataToGenerateGraph.length > 0;
      if (hasDataToGenerateGraph) {
        const isHourType = typeApi === 3;
        const isWeekDayType = typeApi === 2;
        const isMonthType = typeApi === 1;
        const isDayType = typeApi === 4;
        if (isHourType || isWeekDayType) {
          dataToGenerateGraph.sort((a, b) => {
            const numberA = Number(a.name);
            const numberB = Number(b.name);

            const isNumbersValids =
              typeof numberA === "number" && typeof numberB === "number";
            if (isNumbersValids) {
              return numberA - numberB;
            }

            return 0;
          });
        } else if (isMonthType) {
          dataToGenerateGraph.sort((a, b) => {
            const dateA = parse(a.name, "yyyy-MM", new Date());
            const dateB = parse(b.name, "yyyy-MM", new Date());
            const isDateValid = !!dateA && !!dateB;
            if (isDateValid) {
              return compareAsc(dateA, dateB);
            }
            return 0;
          });
        } else if (isDayType) {
          dataToGenerateGraph.sort((a, b) => {
            const dateA = parse(a.name, "yyyy-MM-dd", new Date());
            const dateB = parse(b.name, "yyyy-MM-dd", new Date());
            const isDateValid = !!dateA && !!dateB;
            if (isDateValid) {
              return compareAsc(dateA, dateB);
            }
            return 0;
          });
        }
      }
      setDataEvo(dataToGenerateGraph);
      setDispareFilter(true);
      setLoading(false);
      return;
    }

    setDataEvo(dataToGenerateGraph);
    setLoading(false);
  }

  async function getNpsQuestVersion2(typeApi) {
    setLoading(true);
    let dataToGenerateGraph = [];

    const response = await APIDashboard.getNpsQuestV2(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join(),
      typeApi,
      filtersDashboard.questionsNPS.map((option) => option.id).join(),
      filtersDashboard.questionsCSAT.map((option) => option.id).join(),
      filtersDashboard.channels.map((option) => option.id).join(),
    );

    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const results = response.data;
      const hasResults = !!results && results.length > 0;
      if (hasResults) {
        const groupedByDateResults = groupBy(results, "data_nps");
        const hasGroupedByDateResults = !!groupedByDateResults;

        if (hasGroupedByDateResults) {
          for (let keyName in groupedByDateResults) {
            const name = keyName;
            let npsO = 0;
            let npsT = 0;
            const arrWithData = groupedByDateResults[keyName];
            const hasArrWithData = !!arrWithData && arrWithData.length > 0;
            if (hasArrWithData) {
              arrWithData.forEach((data) => {
                const isOriginalData = !!data.resultado;
                const isTreatedData = !!data.resultado_tratativa;
                if (isOriginalData) {
                  npsO = data.resultado;
                } else if (isTreatedData) {
                  npsT = data.resultado_tratativa;
                }
              });
            }

            dataToGenerateGraph.push({
              name,
              npsO,
              npsT,
              meta: metaValue,
            });
          }
        }
      }
      setDataEvo(dataToGenerateGraph);
      setDispareFilter(true);
      setLoading(false);
      return;
    }

    setDataEvo(dataToGenerateGraph);
    setLoading(false);
  }

  async function getNPSQuest(typeApi) {
    setLoading(true);
    const response = await APIDashboard.getNpsQuest(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join(),
      typeApi,
      filtersDashboard.questionsNPS.map((option) => option.id).join(),
      filtersDashboard.questionsCSAT.map((option) => option.id).join(),
      filtersDashboard.channels.map((option) => option.id).join(),
    );

    if (response && response.status === 200) {
      const data = response.data;
      let stringDate = type === 1 ? "MM/yyyy" : type === 2 ? "cccc" : "HH:mm";
      const dataGraph = data.map((datum) => {
        return {
          name: datum.data_nps,
          npsO: datum.resultado,
          meta: metaValue,
        };
      });

      // dataGraph.push({
      //   name: format(new Date("2024/01/15"), stringDate),
      //   npsO: 118,
      //   meta: 100,
      // });

      setDataEvo(dataGraph);
      setDispareFilter(true);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde.",
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }
    setLoading(false);
  }

  const CustomYAxisTick = ({ x, y, payload }) => {
    return (
      <g transform={`translate(${20},${y + 4})`}>
        <text
          x={0}
          y={0}
          textAnchor="start"
          fill="rgba(0, 0, 0, 0.38)"
          style={{ fontFamily: "Inter", fontSize: 12 }}
        >
          {payload.value}%
        </text>
      </g>
    );
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const isNpsOANumber = typeof payload[0].payload.npsO === "number";
      let isNpsTANumber = false;
      const npsTreatedInfos = payload.find((datum) => {
        return datum.dataKey === "npsT";
      });
      const hasNpsTreatedInfos = !!npsTreatedInfos;
      if (hasNpsTreatedInfos) {
        isNpsTANumber = typeof npsTreatedInfos.payload.npsT === "number";
      }
      let t1 = "00-00";
      if (type !== 2 && type !== 3 && type !== 4) {
        t1 = payload[0].payload.name.split("-");
      }
      return (
        <div className="custom-tooltip">
          <p className="label">
            {type === 2
              ? handleWeek(payload[0].payload.name)
              : type === 3
                ? `${payload[0].payload.name}:00`
                : type === 4
                  ? handleDateFormat(payload[0].payload.name)
                  : // : format(
                    //     new Date(payload[0].payload.name.replaceAll("-", "/")),
                    //     "MM/yyyy",
                    //     {
                    //       locale: ptBR,
                    //     }
                    //   )}
                    // o codigo acima nao funciona no safari
                    `${t1[1]}/${t1[0]}`}
          </p>
          <Typography.H5 weight="400" color="gray-180">
            NPS Original:{" "}
            {isNpsOANumber
              ? payload[0].payload.npsO.toFixed(2)
              : payload[0].payload.npsO}
            %
          </Typography.H5>
          {hasNpsTreatedInfos && (
            <Typography.H5 weight="400" color="gray-180">
              NPS Tratado:{" "}
              {isNpsTANumber
                ? npsTreatedInfos.payload.npsT.toFixed(2)
                : npsTreatedInfos.payload.npsT}
              %
            </Typography.H5>
          )}
          <Typography.H5 weight="400" color="gray-180">
            Meta: {payload[0].payload.meta}%
          </Typography.H5>
        </div>
      );
    }

    return null;
  };

  const buttonsFilter = (button) => {
    const dateInit = new Date(filtersDashboard.datestart);
    const dateEnd = new Date(filtersDashboard.dateend);
    const diffDays = calcDiffDays();

    if (dateInit.toDateString() === dateEnd.toDateString()) {
      return button.key === "hours";
    } else if (diffDays >= 0 && diffDays < 30) {
      return (
        button.key === "hours" ||
        button.key === "day-week" ||
        button.key === "day"
      );
    } else {
      return button;
    }
  };

  const handleActiveButton = () => {
    const dateInit = new Date(filtersDashboard.datestart);
    const dateEnd = new Date(filtersDashboard.dateend);
    const diffDays = calcDiffDays();
    // setLastType(type);

    if (dateInit.toDateString() === dateEnd.toDateString()) {
      setActiveButton("hours");
      setType(3);
      getNpsQuestVersion3(3);
    } else if (diffDays > 0 && diffDays < 30) {
      setActiveButton("day-week");
      setType(2);
      getNpsQuestVersion3(2);
    } else if (diffDays >= 30) {
      setActiveButton("month");
      setType(1);
      getNpsQuestVersion3(1);
    }
  };

  const handleWeek = (weekDay) => {
    switch (weekDay) {
      case 0:
        return "Domingo";
      case "0":
        return "Domingo";
      case 1:
        return "Segunda";
      case "1":
        return "Segunda";
      case 2:
        return "Terça";
      case "2":
        return "Terça";
      case 3:
        return "Quarta";
      case "3":
        return "Quarta";
      case 4:
        return "Quinta";
      case "4":
        return "Quinta";
      case 5:
        return "Sexta";
      case "5":
        return "Sexta";
      case 6:
        return "Sábado";
      case "6":
        return "Sábado";

      default:
        break;
    }
  };

  const calcDiffDays = () => {
    const dateInit = new Date(filtersDashboard.datestart);
    const dateEnd = new Date(filtersDashboard.dateend);
    const timeDiff = Math.abs(dateEnd.getTime() - dateInit.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return diffDays;
  };

  const handleTime = (time) => {
    if (type === 1) {
      const timestamp = Date.parse(time);
      if (!isNaN(timestamp) && typeof time !== "number") {
        // const newTime = time.replaceAll("-", "/");
        // return format(new Date(newTime), "MM/yyyy", {
        //   locale: ptBR,
        // });
        // o codigo acima não funciona no safari
        let t1 = time.split("-");
        return `${t1[1]}/${t1[0]}`;
      } else {
        return time;
      }
    } else if (type === 2) {
      return handleWeek(time);
    } else if (type === 4) {
      return handleDateFormat(time);
    } else {
      return `${time}:00`;
    }
  };

  useEffect(() => {
    const npsDataToUpdate = updateGoalOnNPS(metaValue, dataEvo);
    setDataEvo(npsDataToUpdate);
  }, [metaValue]);

  useEffect(() => {
    handleActiveButton();
    setDispareFilter(true);
  }, []);

  useEffect(() => {
    if (filtersDashboard.active && dispareFilter) {
      handleActiveButton();
    }
  }, [filtersDashboard]);

  return (
    <section className="nps-evolution-quality">
      <header className="nps-evolution-header">
        <div className="cards-headers">
          <h4>Evolução do NPS</h4>
        </div>
        {/* <Typography.H4 weight="500" color="black-2">
          Evolução do NPS
        </Typography.H4> */}

        <div className="nps-evolution-buttons-filter">
          {buttons.filter(buttonsFilter).map(({ key, label, icon, type }) => (
            // ${key}-button antigo classname
            <button
              key={key}
              className={`typetimer-button ${
                activeButton === key ? "active" : ""
              }`}
              onClick={() => handleButtonClick(key, type)}
            >
              {/* <div> */}
              {/* <span> */}
              {activeButton === key ? icon : null}
              <Typography.H6 weight="500" color="gray-180">
                {label}
              </Typography.H6>
              {/* </span> */}
              {/* </div> */}
            </button>
          ))}
        </div>
      </header>

      <div className="nps-evolution__graphic">
        {loading ? (
          <Dots />
        ) : dataEvo.length ? (
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={dataEvo}>
              <XAxis dataKey="name" tickFormatter={handleTime} />
              <YAxis tick={<CustomYAxisTick />} />
              <Tooltip content={<CustomTooltip />} />
              <CartesianGrid stroke="#f5f5f5" />
              <ReferenceLine y={0} stroke="#0000000D" />
              <Bar dataKey="npsO" barSize={15} fill="#C0CA33" />
              <Bar dataKey="npsT" barSize={15} fill="#455CC7" />
              {/* <Area type="linear" dataKey="uv" fill="#b4bde8" stroke="#8884d8" /> */}
              <Line
                type="linear"
                dataKey="meta"
                stroke="#FFB300"
                strokeWidth={2}
                dot={false}
                activeDot={false}
                strokeDasharray="3 3"
              />
            </ComposedChart>
          </ResponsiveContainer>
        ) : (
          <div className="card-table__area-empty">
            <EmptyState />
          </div>
        )}
      </div>

      <div className="nps-evolution-tags">
        <span className="nps-evolution-tags__span">
          <div className="nps-evolution-original" />

          <Typography.H5 weight="500" color="gray-180">
            NPS Original
          </Typography.H5>
        </span>
        <span className="nps-evolution-tags__span">
          <div className="nps-evolution-treated" />

          <Typography.H5 weight="500" color="gray-180">
            NPS Tratado
          </Typography.H5>
        </span>
        <span className="nps-evolution-tags__span">
          {/* <GoalIcon /> */}
          <div className="nps-evolution-goal" />

          <Typography.H5 weight="500" color="gray-180">
            {`Meta de ${metaValue}% `}
          </Typography.H5>
          <div onClick={() => OpenModalMeta()} style={{ cursor: "pointer" }}>
            <EditMetaIcon />
          </div>
        </span>
      </div>

      <MetaValueModalV2
        handleMetaValue={handleMetaValue}
        setValue={setValue}
        value={value}
        setMetaValue={setMetaValue}
        storageKey="ingWebNPS_goal"
        text="Selecione a meta"
      />
    </section>
  );
}
